export const SERVICE_TYPES = [
  { value: "breakdown", label: "Breakdown", icon: "⚡" },
  { value: "towing", label: "Towing", icon: "🚛" },
  { value: "diagnostics", label: "Diagnostics", icon: "🔍" },
  { value: "tire", label: "Flat Tire", icon: "🛞" },
  { value: "battery", label: "Battery Jump", icon: "🔋" },
  { value: "fuel", label: "Fuel Delivery", icon: "⛽" },
  { value: "other", label: "Other", icon: "🔧" },
  { value: "minor_service", label: "Minor Service", icon: "🧰", scheduled: true },
  { value: "major_service", label: "Major Service", icon: "🛠️", scheduled: true },
];

export const SCHEDULED_TYPES = new Set(["minor_service", "major_service"]);

export const STATUS_LABEL = {
  pending: "Pending",
  accepted: "Accepted",
  in_progress: "In Progress",
  completed: "Completed",
  cancelled: "Cancelled",
};

export function formatZAR(n) {
  const v = Number(n || 0);
  return `R ${v.toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function serviceLabel(v) {
  return SERVICE_TYPES.find((s) => s.value === v)?.label || v;
}

export function serviceIcon(v) {
  return SERVICE_TYPES.find((s) => s.value === v)?.icon || "🔧";
}

export function isScheduledType(v) {
  return SCHEDULED_TYPES.has(v);
}

export const ADMIN_WA_NUMBER = "27629901981"; // +27 62 990 1981
